import useFetch from 'utils/hooks/useFetch'
import {
    ApiCheckIsAdmin,
    ApiCreateBrand,
    ApiCreateCategory,
    ApiCreateCustomer,
    ApiCreateProduct,
    ApiCreateRentalStock,
    ApiCreateSalesOrder,
    ApiDeleteBrand,
    ApiDeleteCategory,
    ApiDeleteCustomer,
    ApiDeleteProduct,
    ApiDeleteRentalStock,
    ApiDeleteSalesStock,
    ApiDeleteUser,
    ApiGetBrandList,
    ApiGetCategoryById,
    ApiGetCategoryList,
    ApiGetCustomerById,
    ApiGetCustomerList,
    ApiGetDashboardHeader,
    ApiGetOrderList,
    ApiGetOrderRentalList,
    ApiGetOrderSalesStockList,
    ApiGetProductById,
    ApiGetProductList,
    ApiGetRentalStockById,
    ApiGetRentalStockList,
    ApiGetRentalStockPrice,
    ApiGetSalesStockList,
    ApiGetSystem,
    ApiGetUserList,
    ApiOrderRentalDelivered,
    ApiOrderRentalReturned,
    ApiUpdateCategory,
    ApiUpdateCustomer,
    ApiUpdateProduct,
    ApiUpdateRentalStock
} from 'utils/constants/api'
import { DateFormat } from 'utils/helpers'
import moment from 'moment'

export function useCallApi() {
    // Dashboard
    const { fetch: apiGetDashboardHeader } = useFetch(ApiGetDashboardHeader)

    // Brand
    const { fetch: apiGetBrandList } = useFetch(ApiGetBrandList)
    const { fetch: apiDeleteBrand } = useFetch(ApiDeleteBrand)
    const { fetch: apiCreateBrand } = useFetch(ApiCreateBrand)

    // Category
    const { fetch: apiGetCategoryList } = useFetch(ApiGetCategoryList)
    const { fetch: apiDeleteCategory } = useFetch(ApiDeleteCategory)
    const { fetch: apiCreateCategory } = useFetch(ApiCreateCategory)
    const { fetch: apiGetCategoryById } = useFetch(ApiGetCategoryById)
    const { fetch: apiUpdateCategory } = useFetch(ApiUpdateCategory)

    // Customer
    const { fetch: apiGetCustomerList } = useFetch(ApiGetCustomerList)
    const { fetch: apiDeleteCustomer } = useFetch(ApiDeleteCustomer)
    const { fetch: apiCreateCustomer } = useFetch(ApiCreateCustomer)
    const { fetch: apiUpdateCustomer } = useFetch(ApiUpdateCustomer)
    const { fetch: apiGetCustomerById } = useFetch(ApiGetCustomerById)

    // Product
    const { fetch: apiGetProductList } = useFetch(ApiGetProductList)
    const { fetch: apiDeleteProduct } = useFetch(ApiDeleteProduct)
    const { fetch: apiGetProductById } = useFetch(ApiGetProductById)
    const { fetch: apiCreateProduct } = useFetch(ApiCreateProduct)
    const { fetch: apiUpdateProduct } = useFetch(ApiUpdateProduct)

    // Rental Order
    const { fetch: apiOrderRentalDelivered } = useFetch(ApiOrderRentalDelivered)
    const { fetch: apiOrderRentalReturned } = useFetch(ApiOrderRentalReturned)
    const { fetch: apiGetRentalOrderList } = useFetch(ApiGetOrderRentalList)

    // Rental Stock
    const { fetch: apiGetRentalStockList } = useFetch(ApiGetRentalStockList)
    const { fetch: apiDeleteRentalStock } = useFetch(ApiDeleteRentalStock)
    const { fetch: apiCreateRentalStock } = useFetch(ApiCreateRentalStock)
    const { fetch: apiUpdateRentalStock } = useFetch(ApiUpdateRentalStock)
    const { fetch: apiGetRentalStockById } = useFetch(ApiGetRentalStockById)
    const { fetch: apiGetRentalStockPrice } = useFetch(ApiGetRentalStockPrice)

    // Sales Stock
    const { fetch: apiGetSalesStockList } = useFetch(ApiGetSalesStockList)
    const { fetch: apiDeleteSalesStock } = useFetch(ApiDeleteSalesStock)

    // Sales Order
    const { fetch: apiGetSalesOrderList } = useFetch(ApiGetOrderList)
    const { fetch: apiGetOrderSalesStockList } = useFetch(ApiGetOrderSalesStockList)
    const { fetch: apiCreateSalesOrder } = useFetch(ApiCreateSalesOrder)

    // System
    const { fetch: apiGetSystem } = useFetch(ApiGetSystem)

    // User
    const { fetch: apiGetUserList } = useFetch(ApiGetUserList)
    const { fetch: apiDeleteUser } = useFetch(ApiDeleteUser)
    const { fetch: apiCheckIsAdmin } = useFetch(ApiCheckIsAdmin)

    // ============================================================================

    // Brand
    const fetchBrandList = async(brandName, status, pageSize, index) => {
        return await apiGetBrandList({
            data: {
                brandName, 
                status,
                pageSize,
                pageIndex: parseInt(index)
            }
        })
    }
    const fetchDeleteBrand = async(brandId, status) => {
        return await apiDeleteBrand({
            data: {
                brandId,
                status
            }
        })
    }
    const fetchCreateBrand = async(brandName) => {
        return await apiCreateBrand({
            data: {
                brandName
            }
        })
    }

    // Category
    const fetchCategoryList = async(categoryName, status, pageSize, index) => {
        return await apiGetCategoryList({
            data: {
                categoryName,
                status,
                pageSize,
                pageIndex: parseInt(index)
            }
        })
    }
    const fetchDeleteCategory = async(categoryId, status) => {
        return await apiDeleteCategory({
            data: {
                categoryId,
                status
            }
        })
    }
    const fetchCreateCategory = async(categoryName) => {
        return await apiCreateCategory({
            data: {
                categoryName
            }
        })
    }
    const fetchUpdateCategory = async(categoryId, categoryName) => {
        return await apiUpdateCategory({
            data: {
                categoryId,
                categoryName
            }
        })
    }
    const fetchCategoryById = async(categoryId) => {
        return await apiGetCategoryById({
            data: {
                categoryId
            }
        })
    }

    // Check Is Admin
    const fetchCheckIsAdmin = async(userId) => {
        return await apiCheckIsAdmin({
            data: {
                userId
            }
        })
    }

    // Customer
    const fetchCustomerList = async(customerName, status, pageSize, index) => {
        return await apiGetCustomerList({
            data: {
                customerName,
                status,
                pageSize,
                pageIndex: parseInt(index)
            }
        })
    }
    const fetchDeleteCustomer = async(customerId, status) => {
        return await apiDeleteCustomer({
            data: {
                customerId,
                status
            }
        })
    }
    const fetchCustomerById = async(customerId) => {
        return await apiGetCustomerById({
            data: {
                customerId
            }
        })
    }
    const fetchCreateCustomer = async(customerName, idNumber, address, phone, email, instagram, idPhotoFile) => {
        let data = new FormData()

        data.append('CustomerName', customerName)
        data.append('IdNumber', idNumber)
        data.append('Address', address)
        data.append('Phone', phone)
        data.append('Email', email)
        data.append('Instagram', instagram)
        data.append('Picture', idPhotoFile)

        return await apiCreateCustomer({ 
            data, 
            headers: {
                'Content-type': 'multipart/form-data'
            } 
        })
    }
    const fetchUpdateCustomer = async(customerId, customerName, idNumber, address, phone, email, instagram, idPhotoFile) => {
        let data = new FormData()

        data.append('CustomerId', customerId)
        data.append('CustomerName', customerName)
        data.append('IdNumber', idNumber)
        data.append('Address', address)
        data.append('Phone', phone)
        data.append('Email', email)
        data.append('Instagram', instagram)
        data.append('Picture', idPhotoFile)

        return await apiUpdateCustomer({ 
            data,
            headers: {
                'Content-type': 'multipart/form-data'
            }
        })
    }

    // Dashboard
    const fetchDashboardHeader = async (periode) => {
        return await apiGetDashboardHeader({
        data: { periode }
        })
    }

    // Product
    const fetchProductList = async(productName, brandId, status, pageSize, index) => {
        return await apiGetProductList({
            data: {
                productName, 
                brandId,
                status,
                pageSize,
                pageIndex: parseInt(index)
            }
        })
    }
    const fetchDeleteProduct = async(productId, status) => {
        return await apiDeleteProduct({
            data: {
                productId,
                status
            }
        })
    }
    const fetchProductById = async(productId) => {
        return await apiGetProductById({
            data: {
                productId
            }
        })
    }
    const fetchCreateProduct = async(brandId, category, productName, description, price, priceAfterDiscount, discount, productPhotoFile) => {
        let data = new FormData()

        data.append('BrandId', brandId)
        data.append('categoryId', category)
        data.append('ProductName', productName)
        data.append('Description', description)
        data.append('Price', price)
        data.append('NettPrice', priceAfterDiscount)
        data.append('Discount', discount)
        data.append('Picture', productPhotoFile)

        return await apiCreateProduct({ 
            data, 
            headers: {
                'Content-type': 'multipart/form-data'
            } 
        })
    }
    const fetchUpdateProduct = async(productId, brandId, category, productName, description, price, priceAfterDiscount, discount, productPhotoFile) => {
        let data = new FormData()

        data.append('ProductId', productId)
        data.append('BrandId', brandId)
        data.append('categoryId', category)
        data.append('ProductName', productName)
        data.append('Description', description)
        data.append('Price', price.replaceAll(',', ''))
        data.append('NettPrice', String(priceAfterDiscount).replaceAll(',', ''))
        data.append('Discount', discount)
        data.append('Picture', productPhotoFile)

        return await apiUpdateProduct({ 
            data,
            headers: {
                'Content-type': 'multipart/form-data'
            }
        })
    }

    // Rental Order
    const fetchRentalOrderList = async(customerName, rentalStatus, paymentType, status, pageSize, pageIndex, deliveryStatus) => {
        return await apiGetRentalOrderList({
            data: {
                customerName,
                rentalStatus,
                paymentType,
                status,
                pageSize,
                pageIndex,
                deliveryStatus
            }
        })
    }
    const fetchDeliverRental = async (rentalOrderId) => {
        return await apiOrderRentalDelivered({
            data: { rentalOrderId }
        })
    }
    const fetchReturnRental = async (rentalOrderId, returnedCondition, returnedNotes, returnDate) => {
        return await apiOrderRentalReturned({
            data: {
                rentalOrderId,
                returnedCondition,
                returnedNotes,
                returnDate
            }
        })
    }

    // Rental Stock
    const fetchRentalStockList = async(productName, brandId, stockCode, stockStatus, status, pageSize, index) => {
        return await apiGetRentalStockList({
            data: {
                productName, 
                brandId,
                stockCode,
                stockStatus,
                status,
                pageSize,
                pageIndex: parseInt(index)
            }
        })
    }
    const fetchDeleteRentalStock = async(rentalStockId, status) => {
        return await apiDeleteRentalStock({
            data: {
                rentalStockId,
                status
            }
        })
    }
    const fetchCreateRentalStock = async(productId, stockIn, purchasePrice, rentalPriceHour, rentalPriceDay, rentalPriceSession, sellingPrice) => {
        return await apiCreateRentalStock({
            data: {
                productId,
                stockIn: moment(stockIn).format('YYYY-MM-DDTHH:mm'),
                purchasePrice: purchasePrice.replaceAll(',',''),
                rentalPriceHour: rentalPriceHour.replaceAll(',',''),
                rentalPriceDay: rentalPriceDay.replaceAll(',',''),
                rentalPriceSession: rentalPriceSession.replaceAll(',',''),
                sellingPrice: sellingPrice.replaceAll(',', '')
            }
        })
    }
    const fetchRentalStockById = async(rentalStockId) => {
        return await apiGetRentalStockById({
            data: {
                rentalStockId
            }
        })
    }
    const fetchUpdateRentalStock = async(rentalStockId, productId, stockIn, purchasePrice, rentalPriceHour, rentalPriceDay, rentalPriceSession, sellingPrice) => {
        return await apiUpdateRentalStock({
            data: {
                rentalStockId,
                productId,
                stockIn: moment(stockIn).format('YYYY-MM-DDTHH:mm'),
                purchasePrice: purchasePrice.replaceAll(',',''),
                rentalPriceHour: rentalPriceHour.replaceAll(',',''),
                rentalPriceDay: rentalPriceDay.replaceAll(',',''),
                rentalPriceSession: rentalPriceSession.replaceAll(',',''),
                sellingPrice: sellingPrice.replaceAll(',', '')
            }
        })
    }
    const fetchRentalStockPrice = async(productId) => {
        return await apiGetRentalStockPrice({
            data: {
                productId
            }
        })
    }
    
    // Sales Order
    const fetchSalesOrderList = async(orderDateFrom, orderDateTo, paymentType, status, pageSize, index) => {
        return await apiGetSalesOrderList({
            data: {
                orderDateFrom: DateFormat(orderDateFrom),
                orderDateTo: DateFormat(orderDateTo),
                paymentType,
                status,
                pageSize,
                pageIndex: parseInt(index)
            }
        })
    }
    const fetchOrderSalesStockList = async(categoryId, searchParam) => {
        return await apiGetOrderSalesStockList({
            data: {
                categoryId,
                searchParam
            }
        })
    } 
    const fetchCreateOrderSales = async(cart, paymentType, tax, total, discount, grandTotal) => {
        let items = []

        cart.map((data, i) => items.push({ 
            productId: data.productId, 
            quantity: data.qty, 
            productName: data.productName, 
            brandName: data.brandName, 
            tax: tax,
            size: data.size,
            nettPrice: data.finalPrice
        }))

        return await apiCreateSalesOrder({
            data: {
                items, 
                paymentType,
                tax: parseInt(tax), 
                amount: total.replaceAll(',', ''),
                discount: parseInt(discount),
                nettAmount: grandTotal.replaceAll(',', ''),
            }
        })
    }

    // Sales Stock
    const fetchSalesStockList = async(productName, brandId, stockCode, stockStatus, status, pageSize, index, groupBy) => {
        return await apiGetSalesStockList({
            data: {
                productName, 
                brandId,
                stockCode,
                stockStatus,
                status,
                pageSize,
                pageIndex: parseInt(index),
                groupBy
            }
        })
    }
    const fetchDeleteSalesStock = async(salesStockId, status) => {
        return await apiDeleteSalesStock({
            data: {
                salesStockId,
                status
            }
        })
    }

    // System
    const fetchSystem = async(systemKey) => {
        return await apiGetSystem({
            data: {
                systemKey: systemKey
            }
        })
    }

    // User
    const fetchUserList = async(username, name, status, pageSize, index) => {
        return await apiGetUserList({
            data: {
                username,
                name, 
                status,
                pageSize,
                pageIndex: parseInt(index)
            }
        })
    }
    const fetchDeleteUser = async(userId, status) => {
        return await apiDeleteUser({
            data: {
                userId,
                status
            }
        })
    }

    return {
        fetchDashboardHeader,
        fetchBrandList,             // Brand
        fetchDeleteBrand,
        fetchCreateBrand,
        fetchCategoryList,          // Category
        fetchDeleteCategory,
        fetchCreateCategory,
        fetchUpdateCategory,
        fetchCategoryById,
        fetchCheckIsAdmin,          // Check Is Admin
        fetchCustomerList,          // Customer
        fetchDeleteCustomer,
        fetchCustomerById, 
        fetchCreateCustomer,
        fetchUpdateCustomer,
        fetchProductList,           // Product
        fetchDeleteProduct,
        fetchProductById, 
        fetchCreateProduct,
        fetchUpdateProduct,
        fetchRentalOrderList,       // Rental Order
        fetchDeliverRental,
        fetchReturnRental,
        fetchRentalStockList,       // Rental Stock
        fetchDeleteRentalStock,
        fetchCreateRentalStock,
        fetchRentalStockById,
        fetchUpdateRentalStock,
        fetchRentalStockPrice,
        fetchSalesOrderList,        // Sales Order
        fetchOrderSalesStockList,
        fetchCreateOrderSales,
        fetchSalesStockList,        // Sales Stock
        fetchDeleteSalesStock,
        fetchSystem,                // System
        fetchUserList,              // User
        fetchDeleteUser 
    }
}